const textOverflow = {
  name: "text-overflow",
  path: "/text-overflow",
  title: "text-overflow",
  description: "Utilities for controlling how text is truncated or clipped when it overflows its container.",
  value: {
        "": {
            "truncate":
`overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap`,
        },
    "text-overflow": {
      "text-ellipsis": "ellipsis",
      "text-clip": "clip"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="truncate w-48">This is a long text that will be truncated with an ellipsis if it overflows the container.</p>
<p class="text-ellipsis overflow-hidden whitespace-nowrap w-48">This is a long text that will show an ellipsis.</p>
<p class="text-clip overflow-hidden whitespace-nowrap w-48">This is a long text that will be clipped.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">truncate</code> to apply <code>overflow: hidden</code>, <code>text-overflow: ellipsis</code>, and <code>white-space: nowrap</code>. Use <code>text-ellipsis</code> or <code>text-clip</code> for only <code>text-overflow</code> utilities.
      </p>
      <div class="space-y-6 max-w-xs">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">truncate</small>
          <p class="truncate w-48">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-ellipsis</small>
          <p class="text-ellipsis overflow-hidden whitespace-nowrap w-48">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
          </p>
          <p class="w-48">a word that refers to a lung disease contracted from the inhalation of very fine silica particles, specifically from a volcano; medically, it is the same as silicosis.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-clip</small>
          <p class="overflow-hidden text-clip w-48"><b>pneumonoultramicroscopicsilicovolcanoconiosis,</b> The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default textOverflow;
<div className="truncate w-48 text-ellipsis text-clip overflow-hidden whitespace-nowrap"></div>